import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { isAlphabet } from '../../../common/custom.validator';
import { CommonService } from '../../../common/commonService';
import { urlConstant } from '../../../constant/urlConstant';
import { ToasterService } from 'angular2-toaster';
import { InspectionService } from '../../../services/inspection.service';

@Component({
  selector: 'app-share-info',
  templateUrl: './share-info.component.html',
  styleUrls: ['./share-info.component.scss'],
  animations: [
    trigger('formAnimation', [
      state('form', style({
        opacity: 1,
        display: 'block'
      })),
      transition('* => void', [
        animate('0.3s', style({ opacity: 0 }))
      ]),
      transition('void => *', [
        style({ opacity: 0 }),
        animate('0.3s', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class ShareInfoComponent implements OnInit {
  showForm: boolean = false;
  selectedForm: string = '';
  shareForm: FormGroup;
  title: any;
  userDetail: any = {};
  shareObj: any = {};
  invoceId: any;
  message: any;
  whatsappUrl: any;

  link: any;
  sharedData: any;
  propertyData: any;
  inspectionOpenUrl: any = {};
  ticketOpenUrl: any;
  shareVersionId: any;
  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ShareInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _CommonService: CommonService,
    private toasterService: ToasterService,
    private inspectionService: InspectionService,
  ) {
    this.shareForm = this.formBuilder.group({
      'firstName': new FormControl('', [Validators.required, isAlphabet]),
      'lastName': new FormControl('', [Validators.required, isAlphabet]),
      'email': new FormControl('', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      'mobile': new FormControl('', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
    });

    if (!!this.data) {
      if (!!this.data.type) {

        if (String(this.data.type).toLowerCase() === String("Approval Request").toLowerCase()) {
          this.title = "Send " + this.data.type + " To";
        } else {
          this.title = "Share " + this.data.type + " To";
        }


      }
      if (!!this.data.invoiceId) { this.invoceId = this.data.invoiceId }
      if (!!this.data.propertyData) { this.propertyData = this.data.propertyData }
    }
    this.whatsappUrl = "https://web.whatsapp.com";
  }


  ngOnInit() {
  }

  showUserForm(formName: string, userType: string): void {
    this.showForm = true;
    this.selectedForm = formName;
    if (userType !== undefined) {
      if (!!this.data && !!this.data.userDetailList) {
        this.patchFormValue(this.data.userDetailList, userType)
      }
    }
  }

  animationDone(event: any): void {
    if (event.toState === 'void') {
      this.showForm = false;
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

  changeStatus() {
    this.showForm = false;
  }

  patchFormValue(userDetailList: any[], userType) {
    this.userDetail = {};
    this.shareForm.reset();
    userDetailList.filter((ele: any) => String(userType).toLowerCase() === String(ele.roleName).toLowerCase()).map(val => this.userDetail = val);

    if (!this.isObjectEmpty(this.userDetail)) {
      this.shareForm.patchValue({
        firstName: this.userDetail.firstName,
        lastName: this.userDetail.lastName,
        email: this.userDetail.email,
        mobile: this.userDetail.number,
      })
    }
  }

  share(shareType: string) {
    this.shareObj = {};
    if (this.data.section === "Report") {
      this.shareObj = {
        reportId: this.data.identityId,
        shareTo: this.shareForm.value.firstName + " " + this.shareForm.value.lastName,
        medium: shareType,
        type: this.data.type,
        shareEmail: this.shareForm.value.email
      }
      this._CommonService.showLoading();
      this._CommonService.post(urlConstant.Report.addReportOpenUrl, this.shareObj).subscribe((res: any) => {
        if (res.Status === '200') {
          this.sharedData = res.data.reportOpenUrl;
          this.toasterService.pop("success", "Success", res.message);
          if (String(shareType).toLowerCase() === String("WhatsApp").toLowerCase()) {
            this.link = `${window.location.origin}/dynamic-report/action/${this.sharedData.reportId}`;
            const fullName = this.shareForm.value.firstName + " " + this.shareForm.value.lastName;
            this.message = "Hello " + fullName + ", Dynamic report for Property " + this.data.property.propertyName + " has been generated, Please check via click on below link " + "\n" + this.link;
            window.open(this.whatsappUrl + "/send?phone=91" + this.shareForm.value.mobile + "&text=" + this.message);
          } else {
            if (this.sharedData.emailStatus === true) {
              this.toasterService.pop('success', 'Success', 'Email has send Successfully')
            }
          }

          this.dialogRef.close();
          this._CommonService.hideLoading();
        }
      })
    } else if (this.data.section === "Inspection") {
      if (String(shareType).toLowerCase() === String("WhatsApp").toLowerCase()) {
        this.data['shareTo'] = this.shareForm.value.firstName + " " + this.shareForm.value.lastName;
        this.data['mobile'] = this.shareForm.value.mobile;
        this.data['email'] = this.shareForm.value.email;
        this.clickToChatWhatsapp(this.data, this.data.msg, this.data.section);
        this.dialogRef.close({callback: true});
      } else {
        this.data['shareTo'] = this.shareForm.value.firstName + " " + this.shareForm.value.lastName;
        this.data['email'] = this.shareForm.value.email;
        this.clickToEmail(this.data, this.data.msg, this.data.section);
        this.dialogRef.close({callback: true});
      }
      
    } else if (String(this.data.section).toLowerCase() === String("Service Request").toLowerCase()) {
      if (String(shareType).toLowerCase() === String("WhatsApp").toLowerCase()) {

        this.data.approvalLink =  `${window.location.origin}/ticket/action/${this.data.ticket.id}_sh`
        if(!!this.data.shareFlag && this.data.shareFlag) {
          this._CommonService.showLoading();
          const shareFormData = {
            email: this.shareForm.value.email,
            mobile: this.shareForm.value.mobile,
            firstName: this.shareForm.value.firstName,
            lastName: this.shareForm.value.lastName,
          };
      
          this.whatsappUrl = "https://web.whatsapp.com";
          const fullName = shareFormData.firstName + " " + shareFormData.lastName;
          this.message = "Hello " + fullName + ", Your property Ticket has been updated, Please check via click on below link " + "\n" + this.data.approvalLink;
          window.open(this.whatsappUrl + "/send?phone=91" + this.shareForm.value.mobile + "&text=" + this.message);
          this.toasterService.pop("success", "Success", "");
          this._CommonService.hideLoading();
        }else {
          this.data['shareTo'] = this.shareForm.value.firstName + " " + this.shareForm.value.lastName;
          this.data['mobile'] = this.shareForm.value.mobile;
          this.data['email'] = this.shareForm.value.email;
          this.clickToChatWhatsapp(this.data, this.data.msg, this.data.section);
        }
       
      } else {
        if(!!this.data.shareFlag && this.data.shareFlag === true) {
          this._CommonService.showLoading();
          const shareFormData = {
            email: this.shareForm.value.email,
            fullName: this.shareForm.value.firstName + " " + this.shareForm.value.lastName,
            propertyName: this.propertyData.propertyName,
            ticketNo: this.data.ticket.ticketNo,
            ticketId: this.data.ticketId,
            versionId: this.data.shareVersionId,
          };

          this._CommonService.post(urlConstant.ServiceRequest.sendEmailForTicketShare, shareFormData).subscribe((res:any) => {
            if(res.Status === '200') {
              this.toasterService.pop("success", "Success", res.message);
            }else {
              this.toasterService.pop("error", "Error", res.message);
            }
          });
          this._CommonService.hideLoading();
        }else {
          this.data['firstName'] = this.shareForm.value.firstName;
          this.data['lastName'] = this.shareForm.value.lastName;
          this.data['email'] = this.shareForm.value.email;
          this.data['mobile'] = this.shareForm.value.mobile;
          this.clickToEmail(this.data, this.data.msg, this.data.section);
        }
      
      }
      this.dialogRef.close();
    } else {
      this.shareObj = {
        invoiceId: this.invoceId,
        shareTo: this.shareForm.value.firstName + " " + this.shareForm.value.lastName,
        medium: shareType,
        type: this.data.receiptType,
        shareEmail: this.shareForm.value.email
      }
      this._CommonService.showLoading();
      this._CommonService.post(urlConstant.Invoice.createInvoiceOpenUrl, this.shareObj).subscribe((res: any) => {
        if (res.Status === '200') {
          this.sharedData = res.data.OpenUrl;
          this.toasterService.pop("success", "Success", res.message);
          if (String(shareType).toLowerCase() === String("WhatsApp").toLowerCase()) {
            this.link = `${window.location.origin}/invoice-recipt/action/${this.sharedData.id}`;
            const fullName = this.shareForm.value.firstName + " " + this.shareForm.value.lastName;
            this.message = "Hello " + fullName + ", Invoice receipt for Property " + this.propertyData.propertyName + " has been generated, Please check via click on below link " + "\n" + this.link;
            window.open(this.whatsappUrl + "/send?phone=91" + this.shareForm.value.mobile + "&text=" + this.message);
          }

          this.dialogRef.close();
          this._CommonService.hideLoading();
        }
      })
    }
  }

  isObjectEmpty(obj: Record<string, any>): boolean {
    return Object.entries(obj).length === 0;
  }

  clickToChatWhatsapp(result, msg, section?, callback?) {
    if (String(section).toLowerCase() === String("Service Request").toLowerCase()) {
      const data = {
        ticketId: result.ticketId,
        shareTo: result.shareTo,
        medium: "Whatsapp",
        versionId: result.shareVersionId,
      };

      this._CommonService.post(urlConstant.ServiceRequest.url, data).subscribe((res: any) => {
        if (res.Status === '200') {
          this.toasterService.pop('success', 'Success', "Send");
          this.ticketOpenUrl = res.data.ticketOpenUrl;

          const whatsapp = {
            mobile: result.mobile,
            whatsappUrl: "https://web.whatsapp.com",
            approvalLink: `${window.location.origin}/ticket/action/${this.ticketOpenUrl.id}`,
            message: "Hello, " + result.shareTo + " . msg",
          };

          window.open(whatsapp.whatsappUrl + "/send?phone=91" + whatsapp.mobile + "&text=" + whatsapp.message + whatsapp.approvalLink);
          if (callback) {
            callback();
          }
        }
      })
    } else if (String(section).toLowerCase() === String("Inspection").toLowerCase()) {
      const data = {
        inspectionId: result.inspectionId,
        byCategory: result.byCategory,
        isQuote: result.isQuote,
        status: result.status,
      };
      const openUrl = {
        data: data,
        isQuote: result.isQuote,
        byCategory: result.byCategory,
        status: result.status
      }

      this.inspectionService.addInspectionOpenUrl(openUrl).subscribe(res => {
        if (res.status == '200') {
          this.toasterService.pop('success', 'Success', "Send");
          this.inspectionOpenUrl = res.data.inspectionOpenUrl;
          const whatsapp = {
            mobile: result.mobile,
            whatsappUrl: "https://web.whatsapp.com",
            approvalLink: `${window.location.origin}/inspection/action/${this.inspectionOpenUrl.id}`,
            message: "Hello, " + result.shareTo + " " + result.inspection.inspectionType.status + ". " + msg,
          };

          if(openUrl.status == "SENT-FOR-APPROVAL"){
             whatsapp.approvalLink = `${window.location.origin}/inspection/action/${this.inspectionOpenUrl.id}_ap`
          }
          window.open(whatsapp.whatsappUrl + "/send?phone=91" + whatsapp.mobile + "&text=" + whatsapp.message + whatsapp.approvalLink);
          // if (callback) {
          //   callback();
          // }
        }
      }, (error) => {
        if (error != null) {
          this.toasterService.pop('error', 'Error', error.message);
        }
      });
    }
  }

  clickToEmail(result, msg, section?, callback?) {
    if (String(section).toLowerCase() === String("Service Request").toLowerCase()) {
      const data = {
        ticketId: result.ticketId,
        shareTo: result.firstName + " " + result.lastName,
        medium: "Email",
        versionId: result.shareVersionId,
      };

      this._CommonService.post(urlConstant.ServiceRequest.url, data).subscribe((res: any) => {
        if (res.Status === '200') {
          this.toasterService.pop('success', 'Success', "Send");
          this.ticketOpenUrl = res.data.ticketOpenUrl;

          const shareFormData = {
            email: result.email,
            mobile: result.mobile,
            firstName: result.firstName,
            lastName: result.lastName,
            ticketNo: result.ticket['ticketNo'],
            serviceApprovalLink: `${window.location.origin}/ticket/action/${this.ticketOpenUrl.id}`,
            ticketId: result.ticketId,
          };

          this._CommonService.showLoading();
          this._CommonService.post(urlConstant.ServiceRequest.shareApprovalByEmail, shareFormData).subscribe(res => {
            this._CommonService.hideLoading();
            if (res.Status === '200') {
              this.toasterService.pop('success', 'Success', res.message);
            } else {
              this.toasterService.pop('error', 'Error', res.message);
            }
          }, (error) => {
            this._CommonService.hideLoading();
            if (error != null) {
              this.toasterService.pop('error', 'Error', error.message);
            }
          });
          if (callback) {
            callback();
          }
        }
      })
    } else if (String(section).toLowerCase() === String("Inspection").toLowerCase()) {
      const formData = {
        inspectionId: result.inspectionId,
        shareTo: result.shareTo,
        shareToEmail: result.email,
        status: result.status,
        isQuote: result.isQuote,
        byCategory: result.byCategory
      }
      this._CommonService.showLoading();
      this._CommonService.post(urlConstant.Inspection.shareInspection, formData).subscribe((res: any) => {
        if (res.Status === "200") {
          this.toasterService.pop('success', 'Success', "Successfully Send mail.");
          if (callback) {
            callback();
          }
        }
        this._CommonService.hideLoading();
      }, (error) => {
        if (error != null) {
          this._CommonService.hideLoading();
          this.toasterService.pop('error', 'Error', error.message);
        }
      })
    }
  }
}
